import { render, staticRenderFns } from "./UpdateFollowUp.vue?vue&type=template&id=c4ce1b02&scoped=true"
import script from "./UpdateFollowUp.vue?vue&type=script&lang=js"
export * from "./UpdateFollowUp.vue?vue&type=script&lang=js"
import style0 from "./UpdateFollowUp.vue?vue&type=style&index=0&id=c4ce1b02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4ce1b02",
  null
  
)

export default component.exports